import Box from '@mui/material/Box';

const HeadSectionLayout = (props) => {
  const boxStyles = {
    paddingTop: {
      xs: 'calc(5vh)',
      sm: 'calc(5vh)',
      md: 'calc(12vh)',
      lg: 'calc(15vh)',
    },
    marginLeft: {
      xs: 'calc(2vw)',
      sm: 'calc(2vw)',
      md: 'calc(4vw)',
      lg: 'calc(6vw)',
    },
    paddingLeft: {
      xs: 'calc(2vw)',
      sm: 'calc(2vw)',
      md: 'calc(4vw)',
      lg: 'calc(6vw)',
    },
  };
  return <Box sx={boxStyles}> {props.children} </Box>;
};

export default HeadSectionLayout;
